import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 30px;
  padding-bottom: 1%;
  background-color: #eff3fa;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 60vh;
`

export const SelectorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 18px;
  padding-top: 8px;
`

export const OptionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  width: 100%;

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
  }
`

export const OptionCard = styled.button<{ $active?: boolean; $featured?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  min-height: 144px;
  padding: 22px 22px 20px;
  border-radius: 20px;
  border: 1.5px solid
    ${({ $active, $featured }) =>
      $active ? '#c9006f' : $featured ? '#f3b1d3' : '#d6e2f1'};
  background:
    ${({ $active, $featured }) =>
      $active
        ? 'linear-gradient(135deg, #fff4fa 0%, #ffffff 100%)'
        : $featured
        ? 'linear-gradient(135deg, #fff8fc 0%, #f7fbff 100%)'
        : 'linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)'};
  box-shadow:
    ${({ $active }) =>
      $active
        ? '0 16px 36px rgba(201, 0, 111, 0.12)'
        : '0 12px 30px rgba(39, 91, 143, 0.08)'};
  cursor: pointer;
  text-align: left;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 18px 34px rgba(39, 91, 143, 0.12);
  }
`

export const OptionHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
`

export const OptionIndicator = styled.span<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  border: 2px solid ${({ $active }) => ($active ? '#c9006f' : '#7ea5cd')};
  background: ${({ $active }) => ($active ? '#c9006f' : 'transparent')};
  box-shadow: ${({ $active }) =>
    $active ? '0 0 0 5px rgba(201, 0, 111, 0.12)' : 'none'};
  flex-shrink: 0;

  &::after {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background: #ffffff;
    opacity: ${({ $active }) => ($active ? 1 : 0)};
  }
`

export const OptionText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const OptionEyebrow = styled.span`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6a8198;
`

export const OptionTitle = styled.h3`
  margin: 0;
  font-size: 22px;
  line-height: 1.2;
  font-weight: 700;
  color: #1c2f45;
`

export const OptionDescription = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 1.55;
  color: #5e738a;
`

export const NewBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 999px;
  background: #c9006f;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  box-shadow: 0 10px 22px rgba(201, 0, 111, 0.22);
`

export const FooterContent = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 60px;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: 20px;
`
